import PropTypes from "prop-types";
import { InputTextarea } from "primereact/inputtextarea";
import { classNames } from "primereact/utils";

export default function FormInputtextarea(props) {
  const {
    className = "",
    isControl = true,
    setting: { Controller, control, trigger, isSubmitted, isEdit = true } = {},
    data: {
      name,
      elValue,
      elChange,
      maxlength,
      placeholder = "",
      rows = 5,
      cols = 30,
      disabled = false,
    },
  } = props;

  const onChange = (e, field) => {
    let value = e.target.value;

    if (isControl) {
      field.onChange(value);

      if (isSubmitted) {
        trigger();
      } else {
        trigger(name);
      }
    } else {
      elChange({ name, value, options: props.data });
    }
  };

  const renderElement = ({ field, fieldState } = {}) => {
    let value = isControl ? field.value : elValue;

    return (
      <div className={classNames("flex align-items-center", className)}>
        <InputTextarea
          id={name}
          className={classNames(
            { "p-invalid": isControl && fieldState.invalid },
            "w-full"
          )}
          name={name}
          value={value ?? ""}
          maxLength={maxlength}
          placeholder={placeholder}
          rows={rows}
          cols={cols}
          onChange={(e) => onChange(e, field)}
          disabled={!isEdit || disabled}
        />
      </div>
    );
  };

  return (
    <>
      {isControl ? (
        <Controller
          name={name}
          control={control}
          render={({ field, fieldState }) =>
            renderElement({ field, fieldState })
          }
        />
      ) : (
        renderElement()
      )}
    </>
  );
}

FormInputtextarea.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    cols: PropTypes.number,
    disabled: PropTypes.bool,
    elChange: PropTypes.func,
    elValue: PropTypes.any,
    maxlength: PropTypes.number,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    rows: PropTypes.number,
  }).isRequired,
  isControl: PropTypes.bool,
  setting: PropTypes.shape({
    control: PropTypes.object,
    Controller: PropTypes.elementType,
    isEdit: PropTypes.bool,
    isSubmitted: PropTypes.bool,
    trigger: PropTypes.func,
  }),
};
